export default "__VITE_ASSET__zuAvFKNS__"